import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Accent = ({ parts }) => (
  <>
    {parts[0]}
    <span className="italic text-gold">{parts[1]}</span>
    {parts[2] || ""}
  </>
);

export const SectionHeading = ({ kicker, title, testid }) => (
  <div className="mb-16 md:mb-24">
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold mb-6">{kicker}</p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 data-testid={testid} className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-mist max-w-3xl">
        {title}
      </h2>
    </Reveal>
  </div>
);
